var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1 22.5969H1.64C1.28654 22.5969 1 22.8835 1 23.2369V23.3369C1 23.6904 1.28654 23.9769 1.64 23.9769H21.1C21.4535 23.9769 21.74 23.6904 21.74 23.3369V23.2369C21.74 22.8835 21.4535 22.5969 21.1 22.5969Z",
    fill: "#27353B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.32 7.57687C21.66 7.14687 21.62 6.52687 21.23 6.13687L19.12 4.02687L17.01 1.91686C16.62 1.52687 16 1.48686 15.57 1.82687L3.56 11.2669L7.72 15.4269L11.88 19.5869L21.32 7.57687Z",
    fill: "#F1625C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45001 10.5668L12.58 18.6968L13.37 17.6968L5.45001 9.77679L4.45001 10.5668Z",
    fill: "#27353B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72002 15.4268L3.56002 11.2668C3.04002 12.3968 2.98002 13.6968 3.41002 14.8668L3.48002 15.0568C3.78002 15.8768 3.33002 16.3168 3.06002 17.1468C2.96002 17.4668 3.04002 17.8168 3.28002 18.0568L4.19002 18.9668L5.10002 19.8768C5.34002 20.1168 5.69002 20.1968 6.01002 20.0968C6.83002 19.8268 7.27002 19.3768 8.10002 19.6768L8.29002 19.7468C9.46002 20.1668 10.76 20.1168 11.89 19.5968L7.73002 15.4368L7.72002 15.4268Z",
    fill: "#27353B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27001 18.0469L1.28001 20.0369C1.12001 20.1969 1.17001 20.4569 1.38001 20.5469L3.13001 21.3069C3.35001 21.4069 3.62001 21.3569 3.79001 21.1769L5.10001 19.8669L3.27001 18.0369V18.0469Z",
    fill: "#F1625C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 13.3468L9.79001 11.3668C9.37001 10.9468 9.37001 10.2668 9.79001 9.84676L14.96 4.67676C15.38 4.25676 16.06 4.25676 16.48 4.67676L18.46 6.65676C18.88 7.07676 18.88 7.75676 18.46 8.17676L18.15 8.48676L17.92 8.25676L18.23 7.94676C18.52 7.65676 18.52 7.17676 18.23 6.88676L16.25 4.90676C15.96 4.61676 15.48 4.61676 15.19 4.90676L10.02 10.0768C9.73001 10.3668 9.73001 10.8468 10.02 11.1368L12 13.1168C12.29 13.4068 12.77 13.4068 13.06 13.1168L13.63 12.5268L13.88 12.7568L13.29 13.3468C12.87 13.7668 12.19 13.7668 11.77 13.3468Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27 18.0468L2.47 18.8468L4.53 20.4468L5.1 19.8768L3.27 18.0468Z",
    fill: "#CFBF8A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.c1b5a5e17e4b5c683b887938a6abbef6.svg";
export { ForwardRef as ReactComponent };